<div class="px-plus">
  <common-ui-components-title-summary
    [title]="'فروشگاه‌ها'"
    [showButton]="true"
    [buttonIconReversed]="true"
    [buttonTitle]="'همه'"
    [buttonIcon]="'arrow-2-left'"
    [navigationLink]="'stores/all-stores'"
  ></common-ui-components-title-summary>
</div>
<div class="mt-small">
  <common-ui-components-horizontal-scroll [classes]="'pr-plus'">
    @if (groupedStores()) {
      @for (groupedStore of groupedStores(); track $index) {
        <div class="d-flex flex-column gap-medium">
          <daily-stores-store-preview
            (click)="goToStore(groupedStore[0])"
            [store]="groupedStore[0]"
            [mode]="'logo-only'"
          ></daily-stores-store-preview>
          @if (!$last) {
            <daily-stores-store-preview
              (click)="goToStore(groupedStore[1])"
              [store]="groupedStore[1]"
              [mode]="'logo-only'"
            ></daily-stores-store-preview>
          } @else {
            <div
              class="d-flex flex-column justify-content-space-between h-100 align-items-center"
              (click)="goToAllStoresPage()"
            >
              <ngx-button
                [mode]="'icon-only'"
                [leftIcon]="{ name: 'info-menu', type: 'bold' }"
                [style]="'tinted-on-back'"
                [size]="'large'"
              ></ngx-button>
              <span class="c-2 text-onback-brand text-align-center">بیشتر</span>
            </div>
          }
        </div>
      }
    } @else {
      @for (skeleton of rangeCreator(9); track $index) {
        <div class="d-flex flex-column gap-medium">
          <div class="d-flex flex-column gap-pony">
            <lib-ngx-skeleton-loading
              [width]="'64px'"
              [height]="'64px'"
            ></lib-ngx-skeleton-loading>
            <lib-ngx-skeleton-loading
              [width]="'64px'"
              [height]="'12px'"
            ></lib-ngx-skeleton-loading>
          </div>
          <div class="d-flex flex-column gap-pony">
            <lib-ngx-skeleton-loading
              [width]="'64px'"
              [height]="'64px'"
            ></lib-ngx-skeleton-loading>
            <lib-ngx-skeleton-loading
              [width]="'64px'"
              [height]="'12px'"
            ></lib-ngx-skeleton-loading>
          </div>
        </div>
      }
    }
  </common-ui-components-horizontal-scroll>
</div>
